import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { DynamicFormSettings } from '../../@types/forms';
import { useAppSelector } from '../../redux/hooks';
import { selectActiveMenuItem, selectIsFormLoading } from '../../redux/slices/form-builder-slice';
import { FormLoading } from '../form/form-loading.component';
import FormBuilderAiComponent from './ai/form-builder-ai.component';
import FormBuilderFields from './fields/form-builder-fields.component';

interface FormBuilderContentAreaProps {
  formConfig?: DynamicFormSettings;
}

const FormBuilderContentArea = ({ formConfig }: FormBuilderContentAreaProps) => {
  const activeMenuItem = useAppSelector(selectActiveMenuItem);
  const isFormLoading = useAppSelector(selectIsFormLoading);
  const { t } = useTranslation();

  const renderItem = useCallback(
    (activeMenuItem: string, formConfig: DynamicFormSettings | undefined) => {
      if (!formConfig) {
        return <div className="flex items-center">{t('form-configuration-not-available')}</div>;
      }
      switch (activeMenuItem) {
        case 'Fields':
          return <FormBuilderFields />;
        case 'AI':
          return <FormBuilderAiComponent formId={formConfig?.id} />;
        default:
          return <div className="flex items-center">{activeMenuItem} feature is not implemented yet</div>;
      }
    },
    [t]
  );

  return (
    <div className="custom-scroll flex flex-1 justify-center overflow-y-auto py-4 pl-4 pr-2">
      <div className="relative flex w-full max-w-[820px] justify-center">
        {isFormLoading ? <FormLoading /> : renderItem(activeMenuItem, formConfig)}
      </div>
    </div>
  );
};

export default React.memo(FormBuilderContentArea);
